import React, { memo, useEffect, useRef, useState } from "react";
import { FilterList } from "./FilterList";
import { toggleFilterPanel, scrollToTop } from './HelperFunctions'

export const FilterArea = memo(({ setItemGroups, setItemsLoading }) => {
    var [filterList, setFilterList] = useState(model.filterReponseInfo.FiltersList);
    var filtersDisabled = useRef(false);

    const [activeFilterList, setActiveFilterList] = useState(() => {
        const storageactiveFilterList = sessionStorage.getItem('activeFilterList');
        return storageactiveFilterList ? JSON.parse(storageactiveFilterList) : {};
    });

    useEffect(() => {
        Promise.all([updateFilterList(), UpdateProductList()]);
        if (window.innerWidth < 768 && !$.isEmptyObject(activeFilterList)) {
            $("#mobile-number-filters").html('&nbsp;(' + Object.keys(activeFilterList).length + ')');
            $("#mobile-number-filters").show();
        }
        else $("#mobile-number-filters").hide();
        sessionStorage.setItem('activeFilterList', JSON.stringify(activeFilterList));
    }, [activeFilterList]);

    useEffect(() => {
        if (window.innerWidth < 768) {
            document.body.addEventListener('click', (e) => closeFilterPanel(e));
            return function cleanup() {
                window.removeEventListener('click', (e) => closeFilterPanel(e));
            }
            return function cleanup() {
                $(document).off('click');
            }
        }
    }, [])

    const closeFilterPanel = (event) => {
        if ($('#mobileFilters').hasClass('slide-in-mobile') && !$(event.target).closest('#filterLabelMobile').length
            && !$(event.target).closest('#mobileFilters').length && !$(event.target).closest('.ClearAllFilters').length
            && !$(event.target).closest('.RemoveFilterBubble').length) {
            toggleFilterPanel();
        }
    }

    const filterBubbles = [];
    Object.keys(activeFilterList).forEach(function (key) {
        filterBubbles.push(
            <span key={key} className="FilterBubbleStyle tk-trade-gothic-next">
                <span className="FilterBubbleName">{activeFilterList[key]}</span>
                <span className="RemoveFilterBubble" onClick={() => handleFilterClick($(`.form-check[data-filterkey='${key}']`))}>&nbsp;x</span>
            </span>
        );
    });

    return (
        <div id="FilterContainer" className="tw-min-w-[165px] tw-bg-white md:tw-bg-transparent tw-max-w-none md:tw-max-w-[252px] tw-mr-0 md:tw-mr-[28px]">
            <div id="FilterArea" className="tw-flex-col">
                <div id="ToggleableContainer" className="ThinScrollBarContainer tw-h-[82vh] md:tw-h-auto tw-overflow-auto md:tw-overflow-visible">
                    {filterBubbles.length > 0 &&
                        <div className="filterBubbleSection tw-pl-[19px]" style={{ borderBottom:"1.5px solid #E9E9E9"} }>
                            <div className="filterHeader tw-flex tw-justify-between align-items-center tw-mb-[10px]">
                                <div className="FilterCategoryLabel tw-bt-[10px]">Filter</div>
                                <span className="ClearAllFilters tk-trade-gothic-next" onClick={() => setActiveFilterList({})}>Clear all</span>
                            </div>
                            {filterBubbles}
                        </div>
                    }
                    <FilterList handleFilterClick={handleFilterClick} filterList={filterList} activeFilterList={activeFilterList} />
                </div>
                {window.innerWidth < 768 && (
                    <div id="AnimationFilterContainer" className="hide absolute-center" style={{ width: "fit-content", height: "fit-content" }} >
                        <div className="col-md-12">
                            <i className="fas fa-spinner fa-spin" id="SpinnerAnimation"></i>
                        </div>
                    </div>
                )}
            </div>
            {window.innerWidth < 768 && (
                <div onClick={toggleFilterPanel} className="tw-cursor-pointer tw-inline-flex tw-bg-tamarillo-700 tw-px-7 tw-text-[19px] tw-leading-none tw-text-white tw-justify-center tw-mx-[19px] tw-h-[51px] tw-items-center tw-mb-[30px]">
                    DONE
                </div>
            )}
        </div>
    )

    function handleFilterClick(e) {
        if (filtersDisabled.current) return;
        DisableFilterCheckBoxes();
        const clickedDiv = $(e.currentTarget ?? e);
        const clickedKey = clickedDiv.attr('data-filterkey').trim();

        setActiveFilterList(activeFilterList => {
            if (clickedKey in activeFilterList) {
                const removeKey = (key, { [key]: _, ...rest }) => rest;
                return removeKey(clickedKey, activeFilterList);
            }
            else {
                return { ...activeFilterList, [clickedKey]: clickedDiv.attr('data-filteroption') };
            }
        });
    }

    function updateFilterList() {
        if ($.isEmptyObject(activeFilterList)) {
            setFilterList(model.filterReponseInfo.FiltersList);
            EnableFilterCheckBoxes();
        }
        else {
            var params = {
                "CategoryNo": model.filterReponseInfo.ProductCategory,
                "ActiveFilterList": Object.keys(activeFilterList),
            }
            handleAjaxPost(params, "/products/GetFilterListByCategory", function (data) {
                setFilterList(data.FiltersList);
                EnableFilterCheckBoxes();
            });
        }
    }

    function UpdateProductList() {
        if ($.isEmptyObject(activeFilterList)) {
            setItemGroups(model.itemGroupModel);
            scrollToTop();
        }
        else {
            setItemsLoading(true);
            var params = {
                "CategoryRecNo": model.filterReponseInfo.ProductCategory,
                "ActiveFilterList": Object.keys(activeFilterList),
                "time": Date.now()
            }
            handleAjaxPost(params, "/products/GetFilteredResultForCategory", function (data) {
                setItemGroups([...model.itemGroupModel.filter(item => data.includes(item.ItemGroupRecNo))]);
                setItemsLoading(false);
                scrollToTop();
            });
        }
    }

    function DisableFilterCheckBoxes() {
        filtersDisabled.current = true;
        $('#FilterArea').css('opacity', '0.5');
        $('#AnimationFilterContainer').removeClass('hide');
    }

    function EnableFilterCheckBoxes() {
        $('.ClearAllFilters').show();
        $('#AnimationFilterContainer').addClass('hide');
        $('#FilterArea').css('opacity', '1');
        filtersDisabled.current = false;
    }
})